import * as React from 'react';
const MailIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={19}
    viewBox="0 0 24 19"
    fill="prop"
    {...props}
  >
    <path
      d="M23.3333 2.63614C23.3333 1.37318 22.2833 0.339844 21 0.339844H2.33333C1.05 0.339844 0 1.37318 0 2.63614V16.4139C0 17.6769 1.05 18.7102 2.33333 18.7102H21C22.2833 18.7102 23.3333 17.6769 23.3333 16.4139V2.63614ZM21 2.63614L11.6667 8.37688L2.33333 2.63614H21ZM21 16.4139H2.33333V4.93244L11.6667 10.6732L21 4.93244V16.4139Z"
      fill={props.color}
      {...props}
    />
  </svg>
);
export default MailIcon;
